import { map } from "rxjs";
import apiService from "./ApiService";
import { WelcomeImages } from "../model/WelcomeImages";

export const getWelcomeImages = () => {
  return apiService
    .get<{ welcome: WelcomeImages }>({
      path: "studio/images-app",
      headers: {
        "X-Blk-Brand": null as any, // remove to avoid CORS issue
        "X-Blk-User-Agent": "Blacknut/1.0.0 app/1.0.0",
      },
      requiresAuthPolicy: null as any, // no auth
      cms: true,
    })
    .pipe(map((res) => res.welcome));
};
